import React from 'react';

type SkeletonVariants = undefined | 'default' | 'checkbox' | 'avatar';

export type TableContextValue = {
  variants: SkeletonVariants[];
  isLoading: boolean;
  placeholderRowsCount: number;
  setVariants: (variants: SkeletonVariants[]) => void;
};

export const TableContext = React.createContext<null | TableContextValue>(null);
